import { emailValidation } from '@eneco/common/validation/emailRegex';
import * as yup from 'yup';


export const registerOrgEmailSchema = yup.object({
  emailAddress: emailValidation({ emailMessage: 'emailInvalid', requiredMessage: 'emailRequired' }),
  primaryEmailOverride: yup.string().email('emailOverrideInvalid'),
});
